import {Button} from '../../ui-components/Button/button';
import {DownloadImage, EditImage, FolderDark, HomeLine, SocialShareIcon} from '../../ui-components/Iconpack';
import React, {useState} from 'react';
import {DownloadFile} from '../../utils/helper';
import {useNavigate} from 'react-router-dom';
import Breadcrumbs from '../../ui-components/Breadcrumbs/breadcrumbs';
import {CommonSpinLoader} from '../../ui-components/loaders';
import {Dialog, DialogContent, DialogTrigger} from 'src/ui-components/Modal';
import SocialShare from '../social-share/SocialShare';
import {EventNames} from '../../lib/analytics/events';
import Tracker from '../../lib/analytics/tracker';

interface imageData {
    imageUrl: string;
    fileName: string;
    fileUid: string;
    transformId?: string;
}

export default function ImageView({imageUrl, fileName, fileUid, transformId}: imageData) {
    const [imageLoading, setImageLoading] = useState(true);

    const navigate = useNavigate();
    const transformImage = () => {
        navigate(`/transformation/${fileUid}${transformId ? `?transformId=${transformId}` : ''}`);
    };

    return (
        <Dialog>
            <div className='flex w-full flex-col' style={{boxShadow: '0px -8px 16px -4px rgba(102, 112, 133, 0.7)'}}>
                <div className={'sticky md:hidden'}>
                    <Breadcrumbs
                        items={[
                            {
                                label: <HomeLine />,
                                path: '/',
                            },
                            {
                                label: <FolderDark />,
                                path: '/media-library',
                            },
                            {
                                label: fileName,
                            },
                        ]}
                    />
                </div>
                <div className='flex w-full flex-col'>
                    <div className='flex justify-center gap-4 pb-[60px] pr-[50px] pt-6 md:gap-8'>
                        <Button
                            className='text-[12px] font-[700] text-[#0C111D] md:text-[1rem]'
                            variant='link'
                            icon
                            onClick={transformImage}>
                            <EditImage />
                            Transform Image
                        </Button>
                        <Button
                            className='text-[12px] font-[700] text-[#0C111D] md:text-[1rem]'
                            variant='link'
                            icon
                            onClick={() => DownloadFile(imageUrl, fileName)}>
                            <DownloadImage />
                            Download Image
                        </Button>
                        <DialogTrigger>
                            <Button
                                className='text-[12px] font-[700] text-[#0C111D] md:text-[1rem]'
                                variant='link'
                                icon
                                onClick={() => {
                                    Tracker.trackEvent(EventNames.SHARE_IMAGE_CLICKED);
                                }}>
                                <SocialShareIcon height={20} width={20} />
                                Share Image
                            </Button>
                        </DialogTrigger>
                    </div>
                </div>

                <div className='flex items-center justify-center'>
                    {imageLoading && (
                        <div className={'my-20 flex justify-center'}>
                            <CommonSpinLoader size={'sm'} />
                        </div>
                    )}
                    <img
                        src={imageUrl}
                        alt='Loading'
                        className='max-h-[343px] max-w-[343px] md:max-h-[450px] md:max-w-[450px]'
                        style={{display: imageLoading ? 'none' : 'block'}}
                        onLoad={() => setImageLoading(false)}
                    />
                </div>
            </div>
            <DialogContent className='w-[333px] md:w-[1063px]'>
                <SocialShare imageUrl={imageUrl} />
            </DialogContent>
        </Dialog>
    );
}
